import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { PontoDiarioMarketing, KpisMarketing } from '../../../src/lib/marketing/agregacaoDiaria';
import MultiTooltip from '../../../src/components/marketing/MultiTooltip';

const fmtDate = (d: string) => { const [, m, day] = d.split('-'); return `${day}/${m}`; };

interface Props {
  byDay: PontoDiarioMarketing[];
  kpis: Pick<KpisMarketing, 'totalConversations' | 'totalLeads' | 'totalLandingViews'>;
}

// Extraído de views/Marketing/MetaDashboard.tsx ("Resultados por Dia") pra
// ser reaproveitado também no Painel Executivo.
const ResultadosPorDiaChart: React.FC<Props> = ({ byDay, kpis }) => {
  const resultsData = useMemo(() => byDay.map(d => ({
    date: fmtDate(d.date), conversations: d.conversations,
    leads: d.leads, landingPages: d.landingPageViews,
  })), [byDay]);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h3 className="text-sm font-semibold text-gray-800 dark:text-white mb-0.5">Resultados por Dia</h3>
      <p className="text-xs text-gray-400 dark:text-gray-500 mb-3">
        {[kpis.totalConversations > 0 && 'Conv. WhatsApp', kpis.totalLeads > 0 && 'Leads', kpis.totalLandingViews > 0 && 'Visitas à Página'].filter(Boolean).join(' + ')}
      </p>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={resultsData} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} tickLine={false} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11 }} tickLine={false} width={30} />
          <Tooltip content={<MultiTooltip />} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          {kpis.totalConversations > 0 && <Bar dataKey="conversations" name="Conversas Iniciadas" stackId="r" fill="#3b82f6" />}
          {kpis.totalLeads > 0 && <Bar dataKey="leads" name="Leads / Cadastros" stackId="r" fill="#8b5cf6" />}
          {kpis.totalLandingViews > 0 && <Bar dataKey="landingPages" name="Visitas à Página" stackId="r" fill="#f59e0b" radius={[3, 3, 0, 0]} />}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ResultadosPorDiaChart;
